import { css, Theme } from '@emotion/react';

const SCROLL_WIDTH = 14;

export const SCROLL = (theme: Theme, showScrollbar: boolean) => css`
  scrollbar-color: ${showScrollbar
    ? `${theme.scrollbar.thumbBackground} ${theme.scrollbar.trackBackground}`
    : 'transparent transparent'};
  scrollbar-width: ${showScrollbar ? 'auto' : 'none'};

  ::-webkit-scrollbar {
    width: ${showScrollbar ? SCROLL_WIDTH : 0}px;
    height: ${showScrollbar ? SCROLL_WIDTH : 0}px;
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.scrollbar.thumbBackground};
    border-radius: 10px;
    border: solid ${showScrollbar ? 2 : 0}px ${theme.scrollbar.thumbBorder};
  }

  ::-webkit-scrollbar-track {
    background: ${theme.scrollbar.trackBackground};
    border-radius: 10px;
    margin: ${showScrollbar ? '0 2px 2px 2px' : '0'};
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;
